import React, { Fragment, useContext } from 'react'
import { Card, Grid, List, ListItem, Message } from 'semantic-ui-react'
import { observer } from 'mobx-react-lite'
import { RootStoreContext } from '../../../../App/stores/RootStore'
import Moment from "react-moment";

const RequestNoteList: React.FC = () => {
    const rootStore = useContext(RootStoreContext)
    const { requestNotesById } = rootStore.requestNoteStore;

    return (
        <Fragment>
            <Grid columns={3} divided style={{ overflowY: "auto" }}>
                {requestNotesById.map(([group, requestNotes]) => (
                    <Fragment key={group}>
                        {requestNotes.map(requestNote => (
                            <Grid.Column width={8}>
                                <Card.Group>
                                    <Card fluid>
                                        <Card.Content>
                                            <Card.Header>
                                                {requestNote.noteType}
                                            </Card.Header>
                                            <Card.Meta>
                                                <List>
                                                    <ListItem>ID: {requestNote.id}</ListItem>
                                                    <ListItem>Submitted By: {requestNote.createdByName}</ListItem>
                                                    <ListItem>Submitted On: <Moment format={'MMM D YYYY hh:mm:ss A'} date={requestNote.dateCreated} /></ListItem>
                                                </List>
                                            </Card.Meta>
                                            <Card.Description>
                                                <Message content={requestNote.note} />
                                            </Card.Description>
                                        </Card.Content>
                                    </Card>
                                </Card.Group>
                            </Grid.Column>
                        ))}
                    </Fragment>
                ))}
            </Grid>
        </Fragment>
    )
}
export default observer(RequestNoteList);